import React from 'react';
import { Box } from '@chakra-ui/react';

export default function SectionCurve({ fill = 'white', flip = false }) {
	return (
		<Box
			position='relative'
			w='100%'
			lineHeight={0}
			transform={flip ? 'rotate(180deg)' : undefined}
			mt={flip ? 0 : -1}
			mb={flip ? -1 : 0}
			aria-hidden>
			<svg
				viewBox='0 0 1440 64'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				preserveAspectRatio='none'
				style={{ width: '100%', height: '48px', display: 'block' }}>
				<path
					d='M0 32C240 64 480 0 720 32C960 64 1200 0 1440 32V64H0V32Z'
					fill={fill}
				/>
			</svg>
		</Box>
	);
}
